/**
 * @desc undefined
 */
import { DealNoticeEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryDealNoticeParameter = {
  bizIds?: Array<string>
}

const method = 'GET'
const url = '/trade/dealNotice'

export const queryDealNoticeApi = (
  params?: QueryDealNoticeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<DealNoticeEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryDealNoticeApi.method = method
queryDealNoticeApi.url = url
